export default __webpack_public_path__ + "static/media/East_Air_final.9ea04d15.mp3";